import { findOrgRoutes } from 'common/utils/findOrgRoutes'
import { useParams } from 'react-router-dom'
import { routes } from 'routes'

/**
 * Custom hook to get the orgName from the URL
 *
 * @returns {string} The orgName from the URL
 */
export const useOrgNameInUrl = () => {
  const { orgName } = useParams()
  /**
   * Get reserved words from the routes. These are words that can't be an org name because they are used in the routes
   */
  const orgRoutes = findOrgRoutes(routes)
  const reservedWords = orgRoutes?.map((route) => route.path)

  /**
   * Make sure the orgName is not a reserved word
   */
  const orgNameInUrl = !reservedWords.includes(orgName) ? orgName : ''
  return orgNameInUrl
}
